import { render, staticRenderFns } from "./AddPointOfInterest.vue?vue&type=template&id=470271c4&scoped=true"
import script from "./AddPointOfInterest.vue?vue&type=script&lang=js"
export * from "./AddPointOfInterest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470271c4",
  null
  
)

export default component.exports